/** Dias que o .zip da exportação fica disponível para baixar. */
export const DIAS_DA_EXPORTACAO = 7;

type Celula = string | number | boolean | Date | null | undefined;

/** Data e hora de Brasília, como o Excel brasileiro lê ("31/12/2026 14:30"; só a data à meia-noite). */
export function dataCsv(d: Date | string | null | undefined) {
  if (!d) return "";
  const data = new Date(d);
  const p = Object.fromEntries(
    new Intl.DateTimeFormat("pt-BR", { timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
      .formatToParts(data)
      .map((x) => [x.type, x.value]),
  );
  const dia = `${p.day}/${p.month}/${p.year}`;
  return p.hour === "00" && p.minute === "00" ? dia : `${dia} ${p.hour}:${p.minute}`;
}

/** Centavos em reais com vírgula ("1234,56"), que o Excel brasileiro soma como número. */
export const reaisCsv = (centavos: number | null | undefined) => (centavos == null ? "" : (centavos / 100).toFixed(2).replace(".", ","));

/**
 * Texto que o Excel leria como fórmula ganha um apóstrofo na frente. Nome e observação chegam de
 * fora (o paciente preenche pelo link) e `=HYPERLINK(...)` viraria link ou comando ao abrir a
 * planilha. Número, dinheiro negativo e telefone (`+55 (11) ...`) ficam como estão.
 */
export function neutralizarFormula(s: string): string {
  if (/^[=@\t\r]/.test(s)) return `'${s}`;
  if (/^[+-]/.test(s) && !/^[+-][\d\s().,-]*$/.test(s)) return `'${s}`;
  return s;
}

const celula = (v: Celula) => {
  if (v == null) return "";
  const s =
    v instanceof Date ? dataCsv(v) : typeof v === "boolean" ? (v ? "Sim" : "Não") : typeof v === "number" ? String(v) : neutralizarFormula(String(v));
  return /[;"\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** CSV com ";" e BOM — o Excel brasileiro abre com acentos e colunas certas (como o exportarTabela). */
export function csv(colunas: string[], linhas: Celula[][]) {
  return "﻿" + [colunas, ...linhas].map((l) => l.map(celula).join(";")).join("\r\n") + "\r\n";
}

/** Nome que vale como arquivo ou pasta em qualquer sistema: sem / \ : * ? " < > |, sem espaços sobrando. */
export function nomeSeguro(nome: string | null | undefined, reserva = "sem-nome") {
  const limpo = (nome ?? "")
    .replace(/[\u0000-\u001f<>:"/\\|?*]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^\.+|\.+$/g, "")
    .slice(0, 80)
    .trim();
  return limpo || reserva;
}

/** Evita dois arquivos com o mesmo caminho no zip: o segundo vira "nome (2).ext". */
export function caminhosUnicos() {
  const usados = new Set<string>();
  return (caminho: string) => {
    let atual = caminho;
    for (let n = 2; usados.has(atual.toLowerCase()); n++) {
      const ponto = caminho.lastIndexOf(".");
      const barra = caminho.lastIndexOf("/");
      atual = ponto > barra + 1 ? `${caminho.slice(0, ponto)} (${n})${caminho.slice(ponto)}` : `${caminho} (${n})`;
    }
    usados.add(atual.toLowerCase());
    return atual;
  };
}
